import React, {FormEvent, useEffect, useState} from 'react';
import './styles.scss';
import AppSimpleAccordion from '../../../components/app-simple-accordion';
import * as fonts from '../../../util/fonts';
import Icon from '../../../components/icon/Icon';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import AppButton from '../../../components/app-button';
import {countriesAndCodes} from '../../../util/constants';
import {connect, shallowEqual} from 'react-redux';
import ModalTemplate from '../../../components/modal';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
  ErrorMessage,
} from '../../../components/forms';
import {Row} from '../../../components/layout';
import * as Yup from 'yup';
import {put} from '../../../api/api';
import {uriMemberDataSubmit} from '../../../api/endpoints';
import ChangeSuccessModal from '../iban-filter/change-success-modal';
import {compose} from 'redux';
import {setUserBankAccountDataWasUpdated} from '../../../store/actions';

var IBAN = require('iban');

// PassWord verification

const validationSchemaModal = Yup.object().shape({
  password: Yup.string().required(),
});

// PassWord verification

interface InternationalMyInfoDataProps {
  buStyles: any;
  user: any;
  selectedBu: any;
  selectedInsuranceData: any;
  labels: any;
  serviceLabels: any;
  editable: boolean;
  noAuth: boolean;
  bankAccountDataHolder: any;
  setUserBankAccountDataWasUpdated: Function;
}
interface ResidentsFormValues {
  accountNumber: string;
  holderName: string;
}
interface NonResidentsFormValues {
  holderName: string;
  iban: string;
  country: string;
  holderAddress: string;
}

const AppSelectChoice = ({
  resident,
  options,
  onChange,
  buStyles,
  editable,
  bankAccountDataHolder,
}: any) => {
  const handleChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <div className="select-choice-wrapper">
      <select
        name="isResindent"
        defaultValue={resident}
        onChange={handleChange}
        className="styled-input styled-input_small"
        disabled={!editable}>
        {options.map((option: any) => (
          <option
            key={option.value}
            value={option.value}
            style={{color: colors.black}}>
            {option.label}
          </option>
        ))}
      </select>
      <Icon
        className="app-select-choice-icon"
        color={
          editable ? buStyles?.primaryColor || colors.blue : colors.lightGrey
        }
        name={Icons.CHEVRON_DOWN}
        width={'19'}
        height={'19'}
        strokeWidth={'1'}
      />
    </div>
  );
};

const InternationalMyInfoData = ({
  buStyles,
  user,
  selectedBu,
  selectedInsuranceData,
  labels,
  serviceLabels,
  editable,
  noAuth,
  bankAccountDataHolder,
  setUserBankAccountDataWasUpdated,
}: InternationalMyInfoDataProps) => {
  useEffect(() => {
    setRedidentsFormValues({
      accountNumber: selectedInsuranceData?.iban,
      holderName: selectedInsuranceData?.bankData?.holderName,
    });
    setNonRedidentsFormValues({
      holderName: selectedInsuranceData?.bankData?.holderName,
      iban: selectedInsuranceData?.iban,
      country: selectedInsuranceData?.bankData?.country,
      holderAddress: selectedInsuranceData?.bankData?.holderAddress,
    });
  }, [selectedInsuranceData]);

  const options = [
    {
      value: 1,
      label: labels?.myData_Yes,
    },
    {
      value: 0,
      label: labels?.myData_No,
    },
  ];
  const countriesOptions = countriesAndCodes.map(
    (option: {country_code: string; name: string}) => ({
      value: option.country_code,
      label: option.name,
    }),
  );

  countriesOptions.unshift({
    value: '',
    label: '',
  });

  const [isResident, setIsResident] = useState(
    selectedInsuranceData?.bankData?.resident === false ? 0 : 1,
  );
  const [residentFormValues, setRedidentsFormValues] =
    useState<ResidentsFormValues>({
      accountNumber: '',
      holderName: '',
    });
  const [nonResidentFormValues, setNonRedidentsFormValues] =
    useState<NonResidentsFormValues>({
      holderName: '',
      iban: '',
      country: '',
      holderAddress: '',
    });
  const [isValid, setIsValid] = useState(true);
  const [isValidBankAccountNumber, setIsValidBankAccountNumber] =
    useState(true);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState<boolean>(false);

  // PassWord verification
  const [showModal, setShowModal] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [validatingPassword, setValidatingPassword] = useState(false);
  const [validForm, setValidForm] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  // PassWord verification

  const [statusMessage, setStatusMessage] = useState<any>(null);
  const [errorIban, setErrorIban] = useState(false);

  const featureName = 'InternationalInfo';

  const handleChangeResidents = (event: any) => {
    const {name, value} = event.target;
    const updatedFormValues = {
      ...residentFormValues,
      [name]: value,
    };

    const mandatoryFieldsFilled = !!updatedFormValues.holderName;

    const bankAccountNumberPattern = new RegExp(
      '^[a-zA-Z0-9]{3}-[a-zA-Z0-9]{13}-[a-zA-Z0-9]{2}$',
    );
    const validbankAccountNumber = bankAccountNumberPattern.test(
      updatedFormValues.accountNumber,
    );
    setIsValidBankAccountNumber(validbankAccountNumber);
    setSaveButtonEnabled(
      !shallowEqual(residentFormValues, updatedFormValues) &&
        validbankAccountNumber &&
        mandatoryFieldsFilled,
    );
    setRedidentsFormValues(updatedFormValues);
  };

  const handleChangeNonResidents = (event: any) => {
    const {name, value} = event.target;
    const updatedFormValues = {
      ...nonResidentFormValues,
      [name]: value,
    };
    const mandatoryFieldsFilled =
      !!updatedFormValues.holderName &&
      !!updatedFormValues.country &&
      !!updatedFormValues.holderAddress;

    const validIbanRSPattern = new RegExp('^RS35');
    const validIbanRS =
      validIbanRSPattern.test(updatedFormValues.iban) &&
      IBAN.isValid(updatedFormValues.iban);
    setIsValid(validIbanRS);
    setSaveButtonEnabled(
      !shallowEqual(nonResidentFormValues, updatedFormValues) &&
        validIbanRS &&
        mandatoryFieldsFilled,
    );

    setNonRedidentsFormValues(updatedFormValues);
  };

  // PassWord verification
  const handlePasswordIconClick = () => {
    setViewPassword(!viewPassword);
  };

  const handlePassword = async (password: any) => {
    const body = {
      password: password,
    };
    try {
      // await post(uriPostPasswordCheckResult(), JSON.stringify(body));
      handleOnHideModal();
      handleSubmit();
      setValidatingPassword(false);
    } catch {
      setWrongPassword(true);
      setValidatingPassword(false);
    }
  };

  const handleOnHideModal = () => {
    setShowModal(false);
    setWrongPassword(false);
  };
  // PassWord verification

  const handleSubmit = async () => {
    setSaveButtonEnabled(false);

    const body = {
      buId:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.buId
          : selectedBu?.buId,
      memId:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.memId
          : selectedBu?.memId,
      grpId:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.grpId
          : selectedBu?.grpId,
      famId:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.famId
          : selectedBu?.famId,
      grpName:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.grpName
          : selectedBu?.grpName,
      multicode:
        bankAccountDataHolder === 'INDIVIDUAL'
          ? selectedInsuranceData?.multicode
          : selectedBu?.multicode,
      address: selectedInsuranceData.addr,
      city: selectedInsuranceData.city,
      zipCode: selectedInsuranceData.postalcode,
      phone: selectedInsuranceData.phone,
      mobilePhone: selectedInsuranceData.cellPhone,
      email: selectedInsuranceData.email,
      cardName: selectedInsuranceData.name,
      iban:
        isResident == 1
          ? residentFormValues?.accountNumber
          : nonResidentFormValues?.iban,
      username: user.sub,
      bankData: {
        resident: isResident == 1,
        holderName:
          isResident == 1
            ? residentFormValues?.holderName
            : nonResidentFormValues?.holderName,
        country: nonResidentFormValues?.country || null,
        holderAddress: nonResidentFormValues?.holderAddress || null,
      },
    };

    try {
      await put(uriMemberDataSubmit(), body, featureName).then(
        (response: any) => {
          if (response?.result?.status === 'Success') {
            setStatusMessage(true);
          } else {
            setStatusMessage(false);
            setErrorIban(true);
          }
        },
      );
    } catch (e: any) {
      setStatusMessage(false);
      setErrorIban(true);
    }
    setUserBankAccountDataWasUpdated(true);
  };

  return (
    <div className="my-info-wrapper">
      <ChangeSuccessModal
        setShowModal={setStatusMessage}
        showModal={statusMessage}
      />
      <AppSimpleAccordion
        openByDefault={labels?.myData_bankAccountDataExpanded === '1'}
        header={
          <div className="accordion-title-wrapper">
            <p style={{...fonts.M}}>
              {labels?.myData_IntBankAccountDataHeader}
            </p>
          </div>
        }
        content={
          <>
            <p style={{...fonts.SM, padding: '5px'}}>
              {labels?.myData_IntBankAccountDataSubtitle}
            </p>
            <div className="forms-container">
              <p className="m-0" style={{...fonts.SM}}>
                {labels?.myData_IntBankAccountDataFromSerbia}
              </p>
              <AppSelectChoice
                resident={isResident}
                buStyles={buStyles}
                options={options}
                onChange={(value: any) => {
                  setIsResident(value);
                  setSaveButtonEnabled(false);
                  const event = {
                    target: {
                      name: 'isResident',
                      value: value,
                    },
                  };
                  value == 1
                    ? handleChangeResidents(event)
                    : handleChangeNonResidents(event);
                }}
                editable={editable && !noAuth}
              />

              {isResident == 1 && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // setShowModal(true)
                    handleSubmit();
                  }}>
                  <div className="grip-vertical-form">
                    <label className="m-0" style={{...fonts.SM}}>
                      {labels?.myData_IntBankAccountDataAccountNumber}
                      <div className="input-container-my-data">
                        <input
                          className="styled-input"
                          type="text"
                          name="accountNumber"
                          value={residentFormValues?.accountNumber}
                          onChange={handleChangeResidents}
                          readOnly={!editable || noAuth}
                          style={{
                            border: noAuth
                              ? 'none'
                              : !isValidBankAccountNumber ||
                                  !!!residentFormValues?.accountNumber
                                ? '1px solid red'
                                : 'none',
                          }}
                        />
                        {!isValidBankAccountNumber &&
                          !!residentFormValues?.accountNumber && (
                            <p
                              style={{
                                color: 'red',
                                marginTop: '-10px',
                                textAlign: 'right',
                              }}>
                              {labels?.myData_invalidBankAccountNumber}
                            </p>
                          )}
                        {!!!residentFormValues?.accountNumber && !noAuth && (
                          <p
                            style={{
                              color: 'red',
                              marginTop: '-10px',
                              textAlign: 'right',
                            }}>
                            {labels?.myData_mandatoryField}
                          </p>
                        )}
                      </div>
                    </label>
                    <label className="m-0" style={{...fonts.SM}}>
                      {labels?.myData_IntBankAccountDataAccountHolder}
                      <div className="input-container-my-data">
                        <input
                          className="styled-input"
                          type="text"
                          name="holderName"
                          value={residentFormValues?.holderName}
                          onChange={handleChangeResidents}
                          readOnly={!editable || noAuth}
                          style={{
                            border:
                              !noAuth && !!!residentFormValues?.holderName
                                ? '1px solid red'
                                : 'none',
                          }}
                        />
                        {!!!residentFormValues?.holderName && !noAuth && (
                          <p
                            style={{
                              color: 'red',
                              marginTop: '-10px',
                              textAlign: 'right',
                            }}>
                            {labels?.myData_mandatoryField}
                          </p>
                        )}
                      </div>
                    </label>
                  </div>
                  <AppButton
                    className="save-button"
                    disabled={!saveButtonEnabled}>
                    {labels?.myData_iBANSave}
                  </AppButton>
                </form>
              )}
              {isResident == 0 && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // setShowModal(true)
                    handleSubmit();
                  }}>
                  <div className="grip-vertical-form">
                    <label className="m-0" style={{...fonts.SM}}>
                      {labels?.myData_iBAN}
                      <input
                        className="styled-input"
                        type="text"
                        name="iban"
                        value={nonResidentFormValues?.iban}
                        onChange={handleChangeNonResidents}
                        readOnly={!editable || noAuth}
                        style={{
                          border: `${!isValid ? '1px solid red' : 'none'}`,
                        }}
                      />
                      {!isValid && !!nonResidentFormValues?.iban && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-10px',
                            textAlign: 'right',
                          }}>
                          {labels?.myData_invalidIBAN}
                        </p>
                      )}
                      {!!!nonResidentFormValues?.iban && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-10px',
                            textAlign: 'right',
                          }}>
                          {labels?.myData_mandatoryField}
                        </p>
                      )}
                    </label>
                    <label className="m-0" style={{...fonts.SM}}>
                      {labels?.myData_IntBankAccountDataAccountHolder}
                      <input
                        className="styled-input"
                        type="text"
                        name="holderName"
                        value={nonResidentFormValues?.holderName}
                        onChange={handleChangeNonResidents}
                        readOnly={!editable || noAuth}
                        style={{
                          border: `${
                            !!!nonResidentFormValues?.holderName
                              ? '1px solid red'
                              : 'none'
                          }`,
                        }}
                      />
                      {!!!nonResidentFormValues?.holderName && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-10px',
                            textAlign: 'right',
                          }}>
                          {labels?.myData_mandatoryField}
                        </p>
                      )}
                    </label>
                    <label
                      className="m-0"
                      style={{...fonts.SM, position: 'relative'}}>
                      {labels?.myData_IntBankAccountDataCountry}
                      <select
                        defaultValue={
                          nonResidentFormValues?.country ||
                          selectedInsuranceData?.bankData?.country ||
                          countriesOptions[0].value
                        }
                        className="styled-input"
                        name="country"
                        onChange={handleChangeNonResidents}
                        disabled={!editable || noAuth}
                        style={{
                          border: `${
                            !!!nonResidentFormValues?.country
                              ? '1px solid red'
                              : 'none'
                          }`,
                        }}>
                        {countriesOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <Icon
                        className="app-select-country-icon"
                        color={
                          editable && !noAuth
                            ? buStyles?.primaryColor || colors.blue
                            : colors.lightGrey
                        }
                        name={Icons.CHEVRON_DOWN}
                        width={'19'}
                        height={'19'}
                        strokeWidth={'1'}
                      />
                      {!!!nonResidentFormValues?.country && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-10px',
                            textAlign: 'right',
                          }}>
                          {labels?.myData_mandatoryField}
                        </p>
                      )}
                    </label>
                    <label className="m-0" style={{...fonts.SM}}>
                      {labels?.myData_IntBankAccountDataAccountHolderAddress}
                      <textarea
                        className="styled-input"
                        name="holderAddress"
                        value={nonResidentFormValues?.holderAddress}
                        onChange={handleChangeNonResidents}
                        readOnly={!editable || noAuth}
                        disabled={!editable || noAuth}
                        style={{
                          border: `${
                            !!!nonResidentFormValues?.holderAddress
                              ? '1px solid red'
                              : 'none'
                          }`,
                        }}
                      />
                      {!!!nonResidentFormValues?.holderAddress && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '-10px',
                            textAlign: 'right',
                          }}>
                          {labels?.myData_mandatoryField}
                        </p>
                      )}
                    </label>
                  </div>
                  {noAuth ? (
                    <div className="my-data-permission__int">
                      <p style={{...fonts.M, color: buStyles.primaryColor}}>
                        {labels?.myData_noPermission}
                      </p>
                    </div>
                  ) : (
                    <AppButton
                      className="save-button"
                      type="submit"
                      disabled={!saveButtonEnabled}>
                      {labels?.myData_iBANSave}
                    </AppButton>
                  )}
                </form>
              )}
            </div>

            {/* // PassWord verification */}
            <ModalTemplate
              show={showModal}
              onHide={handleOnHideModal}
              cross={true}
              hideFooter={true}>
              <AppForm
                className="patient-validation-form-container"
                initialValues={{
                  password: '',
                }}
                validationSchema={validationSchemaModal}
                onSubmit={(values) => {
                  setValidatingPassword(true);
                  handlePassword(values.password);
                }}>
                <Row style={{...fonts.M, fontWeight: 'bold'}}>
                  {labels?.myData_iBANReimbursement}
                </Row>
                <Row style={{...fonts.M}}>
                  {`${labels?.myData_passwordCheck1} ${user.name}${labels?.myData_passwordCheck2}`}
                </Row>
                <Row className="account-data-row">
                  <AppFormField
                    type={viewPassword ? '' : 'password'}
                    passwordIcon={true}
                    pwdIconClass="pwd-eye-icon"
                    handlePasswordIconClick={() => handlePasswordIconClick()}
                    showPassword={viewPassword}
                    name="password"
                    placeholder="Palavra-passe"
                  />
                </Row>
                <ErrorMessage
                  error={labels?.myData_password_error}
                  visible={wrongPassword}
                />
                <Row className="patient-validation-continue-button-row">
                  <AppFormSubmitButton
                    title={labels?.myData_confirm}
                    className="stepper-continue-button"
                    disabled={!validForm || validatingPassword}
                  />
                </Row>
              </AppForm>
            </ModalTemplate>
            {/* // PassWord verification */}
          </>
        }
      />
      <ModalTemplate
        type="error"
        show={errorIban}
        onHide={() => setErrorIban(false)}
        hideFooter={true}
        cross={true}>
        <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
          {serviceLabels?.services_error}
        </p>{' '}
      </ModalTemplate>
    </div>
  );
};

const mapStateToProps = ({bankAccountDataHolder, selectedBu}: any) => ({
  bankAccountDataHolder: bankAccountDataHolder.value,
  selectedBu: selectedBu.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUserBankAccountDataWasUpdated: (value: any) =>
    dispatch(setUserBankAccountDataWasUpdated(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(InternationalMyInfoData),
);
